/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { UPDATE_BANK_DETAIL } from '@pages/NomineeKYCPage/apis/graphql';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';

import { Graphql } from '@common/graphql';
import { apiConfig } from '@/config/apiConfig';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IUpdateBankDetailMethods extends IPluginMethodMap {
  getUpdateBankDetail(args: any): Promise<any>;
}

export interface UpdateBankDetailProps {
  cnfAccountNumber: string;
  bankName: string;
  accHolderName: string;
  accountNo: string;
  swiftCode: string;
  type: string;
}

export class UpdateBankDetailsPlugin implements IAgentPlugin {
  readonly methods: IUpdateBankDetailMethods;
  constructor() {
    this.methods = {
      getUpdateBankDetail: this.getUpdateBankDetail.bind(this),
    };
  }

  async getUpdateBankDetail(args: UpdateBankDetailProps) {
    return await this.updateBankDetails(args);
  }

  private async updateBankDetails(args: any) {
    delete args?.cnfAccountNumber;
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .mutation(UPDATE_BANK_DETAIL, {
          input: {
            ...args,
          },
        })
        .toPromise();
      if (res?.data) {
        return {
          data: res?.data,
        };
      }
    } catch (err: any) {
      throw err;
    }
  }
}
